var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "div",
        { staticClass: "sticky-top", class: { small: _vm.$wf.isSmDown } },
        [
          _vm._v(
            " " +
              _vm._s(_vm.saleName) +
              " " +
              _vm._s(_vm.computedFriendlyId) +
              " "
          ),
          _vm.$wf.isSmDown
            ? _c(
                "span",
                { staticClass: "mr" },
                [
                  _c(
                    "w-dropdown",
                    {
                      attrs: {
                        items: _vm.toolbarActions,
                        flat: "",
                        right: "",
                        "use-link": "",
                        white: "",
                      },
                      on: {
                        click: function ($event) {
                          return $event()
                        },
                      },
                    },
                    [
                      _c("w-fa", {
                        staticClass: "mr",
                        attrs: { icon: "ellipsis-v" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "", "no-margin": "" } },
        [
          !_vm.$wf.isSmDown
            ? _c(
                "w-col",
                {
                  attrs: {
                    grow: "",
                    lg: "3",
                    md: "3",
                    sm: "12",
                    "no-margin": "",
                  },
                },
                [
                  _c("w-scroll-view", { staticClass: "action-box" }, [
                    !_vm.hideToPayAmount
                      ? _c("div", { staticClass: "total" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$ct("total")) +
                              " EUR " +
                              _vm._s(_vm.sale.TotalIncVAT.toFixed(2)) +
                              " "
                          ),
                        ])
                      : _c("div", { staticClass: "total" }, [_vm._v("   ")]),
                    _c(
                      "div",
                      {
                        staticClass: "action-item",
                        on: {
                          click: function ($event) {
                            return _vm.downloadFile()
                          },
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "download" } }),
                        _vm._v(" " + _vm._s(_vm.$ct("common.download")) + " "),
                      ],
                      1
                    ),
                    !_vm.isMobile
                      ? _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.print()
                              },
                            },
                          },
                          [
                            _c("w-fa", { attrs: { icon: "print" } }),
                            _vm._v(" " + _vm._s(_vm.$ct("common.print")) + " "),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.canPayWithMollie
                      ? _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.pay()
                              },
                            },
                          },
                          [
                            _c("w-fa", { attrs: { icon: "credit-card" } }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.saleName) +
                                " " +
                                _vm._s(_vm.$ct("common.pay")) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.canCreateAutomaticPaymentWithMollie
                      ? _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.payRecurring()
                              },
                            },
                          },
                          [
                            _c("w-fa", { attrs: { icon: "credit-card" } }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("enable-recurring-payments")) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.canCancelAutomaticPaymentWithMollie
                      ? _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.disableRecurringPayments()
                              },
                            },
                          },
                          [
                            _c("w-fa", { attrs: { icon: "credit-card" } }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("disable-recurring-payments")) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.canSign
                      ? _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                _vm.signModalOpen = true
                              },
                            },
                          },
                          [
                            _c("w-fa", { attrs: { icon: "pen" } }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.saleName) +
                                " " +
                                _vm._s(_vm.$ct("common.sign")) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasTicket
                      ? _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                _vm.ticketModalOpen = true
                              },
                            },
                          },
                          [
                            _c("w-fa", { attrs: { icon: "barcode" } }),
                            _vm._v(" TICKET "),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.completed
                      ? _c(
                          "div",
                          { staticClass: "completed" },
                          [
                            _c("w-fa", { attrs: { icon: "check" } }),
                            _vm._v(
                              " " + _vm._s(_vm.$ct("common.completed")) + " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.canPayWithQrCode
                      ? _c("div", { staticClass: "payment-qr" }, [
                          _c("div", { staticClass: "img" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.qrImageUrl,
                                alt: "Betalings qr",
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "text mt" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("pay-with-your-banking-app")) +
                                " "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "grow" }),
                    _c("div", { staticClass: "created-box" }, [
                      _c("div", { staticClass: "created" }, [
                        _c("img", {
                          attrs: { src: "/img/icons/128.png", width: "32" },
                        }),
                        _vm._v(" Created by Winfakt "),
                      ]),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-scroll-view",
            {
              staticClass: "viewer",
              style: { padding: 0 },
              attrs: { tag: "w-col", center: "", lg: "9", md: "9", sm: "12" },
            },
            [
              _c("app-pdf-viewer", {
                ref: "pdfViewer",
                attrs: { images: _vm.pdfImages, blob: _vm.blob },
                on: {
                  "fetch-images": function ($event) {
                    return _vm.fetchPdf(true)
                  },
                  "fetch-blob": function ($event) {
                    return _vm.fetchPdf(false)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.signModalOpen,
            callback: function ($$v) {
              _vm.signModalOpen = $$v
            },
            expression: "signModalOpen",
          },
        },
        [
          _vm.signModalOpen
            ? _c("app-sign-sale-modal", {
                attrs: { sale: _vm.sale, token: _vm.token },
                on: {
                  close: function ($event) {
                    _vm.signModalOpen = false
                  },
                  signed: function ($event) {
                    _vm.fetch(), _vm.fetchPdf(_vm.shouldFetchAsImage)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "click-close": "" },
          model: {
            value: _vm.ticketModalOpen,
            callback: function ($$v) {
              _vm.ticketModalOpen = $$v
            },
            expression: "ticketModalOpen",
          },
        },
        [
          _c("app-ticket-preview", {
            attrs: { ticket: _vm.ticket },
            on: {
              close: function ($event) {
                _vm.ticketModalOpen = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }